module.exports = __webpack_public_path__ + "media/in_house/footer-6781e4bc.jpg";